import PropTypes from 'prop-types';

import { ReactSelectAsyncWithAxios } from '@hivebrite/design-system/Inputs';

const noOptionsMessage = ({ inputValue }) =>
  inputValue
    ? __('Skill %{skill} not found').i__({
        skill: inputValue,
      })
    : __('Search for a skill');

const ReactSelectSkills = ({
  placeholder,
  isMulti,
  multiple,
  ...otherProps
}) => (
  <ReactSelectAsyncWithAxios
    {...otherProps}
    loadOptionsUrl={Routes.search_skills_path({ format: 'json' })}
    placeholder={placeholder || __('Skill')}
    noOptionsMessage={noOptionsMessage}
    multiple={multiple || isMulti}
  />
);

ReactSelectSkills.propTypes = {
  placeholder: PropTypes.string,
};

export default ReactSelectSkills;
